/* The reference table. Every playground uses it differently, so it seeds
   with Role / Person / Notes as a scaffold and the columns themselves are
   editable. */
export function TableEditor({ table, onChange }) {
  const { columns, rows } = table;

  const setColumn = (i, value) => {
    onChange({ ...table, columns: columns.map((c, j) => (j === i ? value : c)) });
  };

  const setCell = (r, c, value) => {
    onChange({
      ...table,
      rows: rows.map((row, ri) => (ri === r ? row.map((v, ci) => (ci === c ? value : v)) : row)),
    });
  };

  const dropColumn = (i) => {
    /* A table with no columns cannot be typed into, so the last one stays. */
    if (columns.length <= 1) return;
    onChange({
      columns: columns.filter((_, j) => j !== i),
      rows: rows.map((row) => row.filter((_, j) => j !== i)),
    });
  };

  return (
    <div className="tablewrap">
      <table className="ref">
        <thead>
          <tr>
            {columns.map((c, i) => (
              <th key={i}>
                <div className="cellhead">
                  <input
                    className="cin"
                    value={c}
                    placeholder={"Column " + (i + 1)}
                    aria-label={"Column " + (i + 1) + " name"}
                    onChange={(e) => setColumn(i, e.target.value)}
                  />
                  <button
                    className="btn-icon"
                    type="button"
                    aria-label={"Delete column " + (c || i + 1)}
                    disabled={columns.length <= 1}
                    onClick={() => dropColumn(i)}
                  >
                    &#10005;
                  </button>
                </div>
              </th>
            ))}
            <th className="rowact" aria-label="Row actions" />
          </tr>
        </thead>
        <tbody>
          {/* With no rows the table still renders, so the columns stay
              editable on a playground nobody has filled in yet. */}
          {!rows.length && (
            <tr>
              <td className="empty" colSpan={columns.length + 1} style={{ padding: "10px" }}>
                No rows yet.
              </td>
            </tr>
          )}
          {rows.map((row, r) => (
            <tr key={r}>
              {row.map((v, c) => (
                <td key={c}>
                  <input
                    className="cin"
                    value={v}
                    aria-label={(columns[c] || "Column " + (c + 1)) + ", row " + (r + 1)}
                    onChange={(e) => setCell(r, c, e.target.value)}
                  />
                </td>
              ))}
              <td className="rowact">
                <button
                  className="btn-icon"
                  type="button"
                  aria-label={"Delete row " + (r + 1)}
                  onClick={() => onChange({ ...table, rows: rows.filter((_, ri) => ri !== r) })}
                >
                  &#10005;
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
